export const stripHtmlTags = (input: string | null | undefined): string =>
	input?.replace(/<[^>]*>/g, "") ?? "";

export const isURL = (input: string): boolean => /^(https?):\/\/[^\s/$.?#].[^\s]*$/.test(input.trim());

const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;
export const hasURL = (input: string): boolean => urlRegex.test(input.trim());
export const getURL = (input: string): string | null => {
	const matches = input.match(urlRegex);
	return matches ? matches[0] : null;
};
export const stripURL = (input: string): string => input.replace(urlRegex, "").trim();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const count = (count: number | any[] | null | undefined, single: string, plural = `${single}s`) => {
	if (Array.isArray(count)) count = count.length;
	return `${count ?? 0} ${count === 1 ? single : plural}`;
};
